module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_5012.b7ca4598.png";